<template>
	<div class="root">
		<div class="payout-information-section">
			<div class="row">
				<div class="col-sm-12">
					<h6 class="text-center text-normal text-danger" v-if="payoutsRestricted">Payouts restricted.
						Please check your profile's Bank Information.</h6>
				</div>
				<div class="col-sm-12" v-if="payoutErrors.has('stripeErrors')">
					<div class="text-center text-danger">
						{{payoutErrors.get('stripeErrors')}}
					</div>
				</div>
				<div class="col-sm-12" v-if="payoutErrors.has('customErrors')">
					<div class="text-center text-danger">
						{{payoutErrors.get('customErrors')}}
					</div>
				</div>
				<div class="col-sm-12" v-if="payoutErrors.has('requested_amount')">
					<div class="text-center text-danger">
						{{payoutErrors.get('requested_amount')}}
					</div>
				</div>
				<div class="col-sm-12" v-if="payoutErrors.has('internalError')">
					<div class="text-center text-danger">
						Something went wrong. Please try again later.
					</div>
				</div>
			</div>

			<div class="margin-top-50">
				<div class="row" v-if="userData.business_name">
					<div class="form-group col-sm-12">
						<label class="hh-input-label">Business name</label>
						<span class="form-control overflow-x hh-gray-9">
                            {{userData.business_name}}
                        </span>
					</div>
				</div>

				<div class="row">
					<div class="form-group col-sm-6">
						<label class="hh-input-label">Payout Receiver</label>
						<span class="form-control overflow-x hh-gray-9">
                                {{userData.first_name}} {{userData.last_name}}
            </span>
					</div>

					<div class="form-group col-sm-6">
						<label class="hh-input-label">Date of Birth</label>
						<span class="form-control overflow-x hh-gray-9">
                                {{userData.date_of_birth}}
                        </span>
					</div>
				</div>

				<div class="row">
					<div class="form-group col-sm-12" v-if="userData.business_name">
						<label class="hh-input-label">Tax ID</label>
						<span class="form-control overflow-x hh-gray-9">
                                {{userData.identification_number}}
                        </span>
					</div>
					<div class="form-group col-sm-12" v-else>
						<label class="hh-input-label">SSN (last 4)</label>
						<span class="form-control overflow-x hh-gray-9">
                                {{userData.identification_number}}
                        </span>
					</div>
				</div>

				<div class="row">
					<div class="form-group col-sm-6">
						<label class="hh-input-label">Account Number</label>
						<span class="form-control overflow-x hh-gray-9">
                                {{userData.account_number}}
                        </span>
					</div>

					<div class="form-group col-sm-6">
						<label class="hh-input-label">Routing Number</label>
						<span class="form-control overflow-x hh-gray-9">
                            {{userData.routing_number}}
                        </span>
					</div>
				</div>

				<div class="row">
					<div class="form-group col-sm-6">
						<label class="hh-input-label">Goal Amount</label>
						<span class="form-control overflow-x hh-blue text-bold hh-amount-container">
                            {{formattedGoalAmount}}
                        </span>
					</div>

					<div class="form-group col-sm-6">
						<label class="hh-input-label">Amount Raised (Including Fees)</label>
						<span class="form-control overflow-x hh-gray-9 text-bold hh-amount-container">
                            {{formattedChargedAmount}}
                        </span>
					</div>
				</div>

				<div class="row">
					<div class="form-group col-sm-6">
						<div class="flex-container flex-direction-column">
							<label class="hh-input-label">Campaign Balance</label>
							<div v-if="availableAmountWarning" class="amount-warning-wrapper">
								<font-awesome-icon :class="availableAmountWarning.class" :icon="availableAmountWarning.icon"/>
						</div>

						<span class="form-control overflow-x hh-gray-9 text-bold hh-amount-container">
                            {{formattedAvailableAmount}}
                        </span>
					</div>
					</div>

					<div class="form-group col-sm-6">
						<label class="hh-input-label">Available for Payout Now</label>
						<span class="form-control overflow-x hh-gray-9 text-bold hh-amount-container">
                            {{formattedAvailableToPayout}}
                        </span>
					</div>

					<div class="col-sm-12 margin-bottom-20" v-if="availableAmountWarning">
						<h6 class="text-left text-normal" :class="availableAmountWarning.class">
							Our payment processor might take up to 5 business days to approve donations. Please check back regularly for any updates.
						</h6>
					</div>
					</div>
				


				<div class="row">
					<div class="form-group col-xs-12">
						<div class="payouts-wrapper">
							<div v-if="payoutsData.data" ref="payoutsContainer" class="payouts-container">
								<p class="col-xs-12 payout-item" v-for="(payout, key) in payoutsData.data"
								   :key="key">
									Payout of ${{payout.amount}} to account number {{payout.account_number}} on
									{{payout.created}}. Status: {{payout.status}}
								</p>
							</div>

							<button v-if="hasMorePayouts" v-show="!loadingPayouts" @click="loadMorePayouts"
							        class="btn hh-btn hh-btn-blue payouts-load-more-btn margin-top-10" name="Load more">Load More
							</button>
							<button v-if="hasMorePayouts" v-show="loadingPayouts" @click="loadMorePayouts"
							        class="btn hh-btn hh-btn-gray payouts-load-more-btn margin-top-10" name="Load more">
								Loading...
							</button>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="form-group col-sm-12">
						<label class="hh-input-label">Fundraiser End Date</label>
						<span class="form-control overflow-x hh-gray-9">
                            {{campaignData.campaign_end_date}}
						</span>
					</div>
				</div>


				

				<div id="campaign-payout-form-data margin-bottom-30" v-show="showForm">
					<div class="form">
						<div class="form-separator"></div>

						<div class="container-fluid">
							<div class="margin-top-30 margin-bottom-30">
								<p class="text-gray text-center">
									You have currently raised <span class="hh-blue">${{formattedRaisedAmount}}</span>
									out of a goal amount of
									<span class="hh-blue">${{formattedGoalAmount}}</span>
								</p>
								<p class="text-gray text-center">
									You have <span class="text-success">${{formattedAvailableToPayout}}</span>
									available
								</p>
							</div>

							<div class="row">
								<div class="form-group col-sm-6 col-md-12">
									<label class="hh-input-label">Enter the amount you would like to receive:</label>
									<CurrencyInput v-model="formData.requested_amount"></CurrencyInput>

									<div class="invalid-feedback-red" v-if="payoutErrors.has('requested_amount')">
										{{payoutErrors.get('requested_amount')}}
									</div>

									<div class="invalid-feedback-red" v-if="customError">
										{{customError}}
									</div>
								</div>
							</div>

							<div class="margin-bottom-20 margin-top-50">
								<div class="row hh-form-btn-wrapper">
									<div class="form-group col-sm-5">
										<button type="button" v-on:click="showForm = !showForm"
												class="btn hh-btn hh-btn-lg hh-btn-gray hh-form-btn text-capitalize" name="Cancel">
											Cancel
										</button>
									</div>
									<div class="form-group col-sm-5">
										<button type="submit" :disabled="!isFormReady"
												@click="openModal"
												class="btn save-btn hh-btn-green btn-responsive" name="Receive funds">
											Receive Funds
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-show="!showForm">
					<div class="margin-bottom-20 margin-top-50">
						<div class="row hh-form-btn-wrapper">
							<div class="form-group col-sm-12">
								<button type="button"
										class="btn hh-btn payout-btn"
										:disabled="this.payoutsRestricted"
										@click="showForm = !showForm"
										title="Get current donated amount now" name="PAY OUT"
								>
									PAY OUT
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<modal ref="payoutModal">
			<template slot="header">
				<div class="margin-top-30 margin-bottom-30 width-100">
					<h3 class="modal-title hh-blue text-center">Are you sure?</h3>
				</div>
			</template>

			<template slot="body">
				<div class="width-100">
					<p class="text-center">
						An amount of <span class="hh-blue">${{formattedRequestedAmount}}</span> will be sent to
						{{userData.name}} at account number {{userData.account_number}}. This action cannot be
						undone.
					</p>
				</div>
			</template>

			<template slot="footer">
				<div class="margin-top-20 margin-bottom-30 width-100">
					<div class="row modal-footer-wrapper">
						<div class="col-sm-4">
							<button type="button" class="btn hh-btn back-btn"
							        @click="$refs.payoutModal.closeModal()" name="Cancel">
								Cancel
							</button>
						</div>
						<div class="col-sm-4">
							<button type="button" class="btn save-btn hh-btn-green btn-responsive"
							        @click="submitForm" name="Receive funds">
								Receive funds
							</button>
						</div>
					</div>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>
	import {mapActions, mapGetters} from 'vuex'

	import Alert from '../../components/form/elements/Alert'
	import Modal from '../../components/form/elements/Modal'
	import CurrencyInput from '../../components/form/elements/CurrencyInput'
	import LoadingAnimation from '../../components/LoadingAnimation'
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
	import {scrollTo} from '../../utils/componentHelper'

	export default {
		name: 'CampaignPayoutInformation',

		components: {
			Alert,
			Modal,
			CurrencyInput,
			LoadingAnimation,
			'font-awesome-icon': FontAwesomeIcon,
		},

		props: {
			campaignSlug: String,
			campaignData: {
				type: Object,
				required: true,
			},
			userData: {
				type: Object,
				required: true,
			},
			payoutsData: {
				type: Object,
				required: true,
			},
		},

		beforeMount() {
		},

		mounted() {
			this.loading = false
		},

		data: () => {
			return {
				loading: true,
				loadingPayouts: false,
				isPayoutFormReady: true,
				forceRecompute: 0,
				showForm: false,
				customError: null,
				currencyFormatter: new Intl.NumberFormat('en-US'),
				config: {},
				componentsLoadingStatus: {},
				formData: {
					requested_amount: 0,
					campaignSlug: null,
				},
			}
		},

		methods: {
			...mapActions('campaign', ['fetchPayouts', 'makePayout']),

			componentLoading(componentName, value) {
				this.componentsLoadingStatus[componentName] = value
			},

			openModal() {
				if (this.validateRequestedAmount()) {
					this.$refs.payoutModal.openModal()
				}
			},

			validateRequestedAmount() {
				if (!this.formData.requested_amount || this.formData.requested_amount < 1) {
					this.customError = 'Invalid value.'
					return false
				}

				if (this.formData.requested_amount > this.formattedAvailableToPayout) {
					this.customError = "The amount of the payout can not be greater than the amount available to pay out."
					return false
				}

				this.customError = null
				return true
			},

			submitForm() {
				this.$refs.payoutModal.closeModal()
				this.loading = true

				if (this.processFormData()) {
					this.sendFormData()
				}

				return true
			},

			processFormData() {
				if (!this.validateRequestedAmount) {
					this.loading = false
					scrollTo(this.$refs['top'])
					return false
				}

				return true
			},

			sendFormData() {
				// this.formData.requested_amount = this.formData.requested_amount.toFixed(2)
				this.formData.campaignSlug = this.campaignSlug


				this.makePayout(this.formData).then(() => {
					this.forceRecompute++
					if (this.payoutStatus === 'success') {

						let alertData = {
							message: 'Your payout has been sent successfully',
							type: 'bg-success',
						}
						this.$emit('formSubmitted', alertData)
						this.formData.requested_amount = 0
						this.showForm = false
					}

					this.loading = false
				})
			},

			loadMorePayouts() {
				this.payoutsData.meta.campaignSlug = this.campaignSlug
				this.loadingPayouts = true
				this.fetchPayouts(this.payoutsData.meta).then(() => {
					for (let [key, item] of Object.entries(this.payouts.data)) {
						this.payoutsData.data.push(item)
					}
					this.payoutsData.meta.current_page++
					this.loadingPayouts = false
				})
			}
		},

		computed: {
			...mapGetters(['alert']),

			payouts: {
				get() {
					return this.$store.getters['campaign/payouts'](this.campaignSlug, this.forceRecompute)
				},
			},

			payoutStatus: {
				get() {
					return this.$store.getters['campaign/payoutStatus'](this.campaignSlug, this.forceRecompute)
				},
			},

			payoutErrors: {
				get() {
					return this.$store.getters['campaign/payoutErrors'](this.campaignSlug, this.forceRecompute)
				},
			},

			isLoading() {
				for (let component in this.componentsLoadingStatus) {
					if (this.componentsLoadingStatus[component]) {
						return true
					}
				}

				return this.loading
			},

			isFormReady() {
				return !this.loading && this.isPayoutFormReady && !this.payoutsRestricted
			},

			payoutsRestricted() {
				switch (this.userData.status_label) {
					case 'Ok':
						return false
					case 'Warning':
					case 'Alert':
					case 'Critical':
					case 'Unknown':
					case 'Review':
						return true
				}
			},

			formattedAvailableToPayout() {
				if (!this.userData.available_to_pay_out) {
					return 0
				}

				return this.currencyFormatter.format(this.userData.available_to_pay_out)
			},

			formattedAvailableAmount() {
				if (!this.campaignData.available_amount) {
					return 0
				}
				return this.currencyFormatter.format(this.campaignData.available_amount)
			},

			formattedGoalAmount() {
				if (!this.campaignData.goal_amount) {
					return 0
				}
				return this.currencyFormatter.format(this.campaignData.goal_amount)
			},

			formattedRaisedAmount() {
				if (!this.campaignData.raised_amount) {
					return 0
				}
				return this.currencyFormatter.format(this.campaignData.raised_amount)
			},

			formattedChargedAmount() {
				if (!this.campaignData.charged_amount) {
					return 0
				}
				return this.currencyFormatter.format(this.campaignData.charged_amount)
			},

			formattedRequestedAmount() {
				if (!this.formData.requested_amount) {
					return 0
				}
				return this.currencyFormatter.format(this.formData.requested_amount)
			},

			hasMorePayouts() {
				if (this.payoutsData == null || this.payoutsData.meta == null) {
					return false
				}

				return this.payoutsData.meta.current_page < this.payoutsData.meta.last_page;
			},

			availableAmountWarning () {
				if (!this.userData.available_to_pay_out || this.userData.available_to_pay_out <  this.campaignData.available_amount) {
					return  {
						'icon': 'exclamation-triangle',
						'class': 'text-alert'
					}
				}

				return null
			}
		},

		watch: {
			isLoading(to, from) {
				this.$emit('componentLoading', 'campaignComponent', to)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.flex-direction-column {
		flex-direction: column;
	}

	.amount-warning-wrapper {
		margin-top: -2rem; 
		margin-left: 13rem;
	}

	.modal-footer-wrapper {
		display: flex;
		justify-content: flex-end;
	}

	.form-control.overflow-x {
		height: 55px; 
		font-family: Circular Std;
		font-style: normal;
		font-weight: 500;
		line-height: 15px; 
		padding:20px;
		letter-spacing: -0.01em;
		color: #000000;
		display: flex;
		align-items: center;
	}

	.payout-btn {
		height: 56px; color: white;  background : #1DC071; width: 100%; font-family: Circular Std;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 16px;
	text-align: center;
	letter-spacing: 0.005em;

	color: white;
	}

	.save-btn {
		margin-bottom: 25px;
	}

	.hh-btn-lg {
		padding: 15px 16px;
	}

	.hh-form-btn-wrapper {
		justify-content: space-between;
	}
</style>